import { connect } from 'react-redux';
import ResponsiblePerson from './ResponsiblePerson';
import {
  getResponsiblePersonsOnStock,
  modalResponsiblePersonsOnStockOpen,
  delResponsiblePersonOnStock
} from '../../store/actions/responsiblePerson';
import { getSettingsPlantStorageTime } from '../../store/actions/stock';

const mapStateToProps = ({
  responsiblePersonReducer,
  stockReducer,
  userReducer,
  tabsReducer
}) => ({
  responsiblePersonReducer,
  stockReducer,
  userReducer,
  tabsReducer
});
const mapDispatchToProps = {
  getResponsiblePersonsOnStock,
  modalResponsiblePersonsOnStockOpen,
  delResponsiblePersonOnStock,
  getSettingsPlantStorageTime
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResponsiblePerson);
